import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/landing';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-5 py-20" data-id="element-25" data-mp="1iy1elzl0yz7r">
      <div className="mx-auto max-w-3xl" data-id="element-26" data-mp="1nvt30jmgo377">
        <h2 className="text-center font-display text-4xl font-bold uppercase leading-none text-ink sm:text-5xl" data-id="element-27" data-mp="1nwvxf1izsnrv">
          Frequently asked <span className="text-gold-dark" data-id="element-28" data-mp="2fmh45vo4x8kv">questions</span>
        </h2>
        <div className="mt-10 divide-y divide-gold-dark/20 border border-gold-dark/20" data-id="element-29" data-mp="2fns8bwlhsici">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="bg-ink-wash" data-id="element-30" data-mp="2uigcn7f5paqj" data-mpi={index}>
                <h3 data-id="element-31" data-mp="2z9omu5ob904r">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-5 px-6 py-5 text-left text-base font-bold text-ink" data-id="element-32" data-mp="2zazyernzzc6f">
                    <span data-id="element-33" data-mp="20p48ebvfre38">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-34" data-mp="20o2lna52535o" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-35" data-mp="2oegeh2vgv61b">
                  {isOpen && <motion.div id={panelId} key="content" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-36" data-mp="2occaym1hc91k">
                      <div className="px-6 pb-6 text-sm font-medium leading-relaxed text-slate-600" data-id="element-37" data-mp="2u4i1bzcbnvz1">
                        {answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}